import React, { useEffect, useRef, useState } from "react";
import companyImage from "../../../../assets/images/company-image.jpg";

const Company = () => {
  const list = [
    { description: "Centralized shipment tracking and management" },
    { description: "Transparent, negotiable pricing" },
    { description: "Access to fleet of loading vehicles" },
    { description: "Company-specific data records and reports" },
  ];

  const maxHeight = window.innerHeight;
  const sectionRef = useRef(null);
  const [fontScale, setFontScale] = useState(1);
  const [isFixed, setIsFixed] = useState(false);
  const [startScroll, setStartScroll] = useState(0);
  const [borderRadius, setBorderRadius] = useState(0);

  useEffect(() => {
    if (sectionRef.current) {
      setStartScroll(sectionRef.current.offsetTop);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      if (scrollY >= startScroll && scrollY <= startScroll + maxHeight) {
        setIsFixed(true);
        const scrolled = scrollY - startScroll;
        const shrinkRatio = Math.max((maxHeight - scrolled) / maxHeight, 0);

        setFontScale(shrinkRatio);
        setBorderRadius(120 * (1 - shrinkRatio)); // smoother & larger curve
      } else if (scrollY < startScroll) {
        setIsFixed(false);
        setFontScale(1);
        setBorderRadius(0);
      } else {
        setIsFixed(true);
        setFontScale(0);
        setBorderRadius(120);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [startScroll]);

  return (
    <>
      {window.innerWidth > 1024 ? (
        <>
          {/* Spacer to prevent layout jump */}
          <div
            className="place-holder-div"
            style={{
              height: isFixed ? `${maxHeight}px` : "auto",
            }}
          />
          <div
            ref={sectionRef}
            style={{
              height: `${maxHeight}px`,
              width: "100%",
              background: "#fff",
              borderRadius: `${borderRadius}px`,
              position: isFixed ? "fixed" : "relative",
              top: 0,
              right: 0, // fixed to right
              left: "auto",
              transform: `scale(${fontScale})`,
              transformOrigin: "top left", // scale from right
              zIndex: 1000,
            }}
          >
            <CompanyContent list={list} borderRadius={borderRadius} />
          </div>
        </>
      ) : (
        <CompanyContent list={list} />
      )}
    </>
  );
};

const CompanyContent = ({ list, borderRadius }) => {
  return (
    <div
      className="company-container"
      style={{
        height: "94%",
        borderRadius: borderRadius,
        width: "auto",
        padding: "0px 60px 60px 60px",
      }}
    >
      <div className="image-container">
        <img
          className="company-image"
          src={companyImage}
          alt="Company"
          style={{
            maxWidth: "70%",
          }}
        />
      </div>
      <div className="container-description" style={{ fontSize: "0.9rem" }}>
        <div className="company-heading" style={{ fontSize: "2rem" }}>
          <span>For Companies & Corporate Accounts: Smart Logistics Management</span>
        </div>
        <div className="company-description" style={{ fontSize: "1.2rem" }}>
          <span>
            Too many shipments, too little time? With a corporate account, you get streamlined data management, easy booking, and trusted drivers - all with transparent pricing and a wide selection of vehicles.
          </span>
        </div>
        <div className="company-list">
          {list.map((item, index) => (
            <div
              key={index}
              className="list-item-company"
              style={{ fontSize: "0.85rem" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={30}
                height={10}
                viewBox="0 0 43 14"
                fill="none"
              >
                <path
                  d="M42.6762 5.86504L31.6524 1.36381L33.2661 13.1613L42.6762 5.86504ZM1.08411 1.05273L0.659674 1.99255C6.54595 4.65087 19.8798 8.80063 33.5313 8.15267L33.4824 7.12262L33.4335 6.09257C20.1897 6.72118 7.18342 2.67577 1.50854 0.11292L1.08411 1.05273Z"
                  fill="black"
                />
              </svg>
              <span>{item.description}</span>
            </div>
          ))}
        </div>
        <button className="ride-with-us" style={{ fontSize: "0.9rem" }}>
          Partner with Us
        </button>
      </div>
    </div>
  );
};

export default Company;
